import { connect } from 'react-redux';
import { Props } from './BrowseDuperContext';
import { AppState } from '../../../types/store';

export type StateProps = Record<string, never>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (_state: AppState): StateProps => ({});

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
);
